<template>
  <div class="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.app {
  max-width: 1920px;
  min-width: 1200px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.main-container {
  position: relative;
  z-index: 5;
  /* margin-bottom: 470px !important; */
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue